import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Alert, Modal, FormGroup, Radio } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';
import FilesTable from './files/table/files_table';

export default function CreateImportModal({
  requestFiles,
  onClose,
  onCreateImport,
  shown
}) {
  const [loadRequestFiles, setLoadRequestFiles] = useState(false);
  const [selectedFileIds, setSelectedFileIds] = useState([]);

  useEffect(() => {
    if (!loadRequestFiles) {
      setLoadRequestFiles(false);
      setSelectedFileIds([]);
    }
  }, [loadRequestFiles]);

  const handleCancel = () => {
    setLoadRequestFiles(false);
    onClose();
  };

  const handleCreate = () => {
    onCreateImport(selectedFileIds);
  };

  const renderFilesList = () => (
    <div className="mt-5">
      <p className="text-muted">Choose which files will be uploaded on import</p>
      <div className="px-5">
        <FilesTable
          files={requestFiles}
          selectedIds={selectedFileIds}
          onSelectedChange={setSelectedFileIds}
        />
      </div>
    </div>
  );

  const renderEmptyState = () => (
    <Alert bsStyle="warning" className="mt-5" name="empty-state">
      <div className="d-flex align-items-center">
        <div className="align-self-center px-3">
          <FontAwesomeIcon icon={faExclamationTriangle} size="sm"/>
        </div>
        <p className="my-0">No files available in import request</p>
      </div>
    </Alert>
  );

  const renderBody = () => (
    requestFiles && requestFiles.length > 0 ? renderFilesList() : renderEmptyState()
  );

  return (
    <Modal className="scrollable-body" show={shown} onHide={handleCancel}>
      <Modal.Header closeButton>
        <Modal.Title>Create New Import</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormGroup>
          <Radio
            checked={!loadRequestFiles}
            name="load-request-files-disable"
            onChange={() => setLoadRequestFiles(false)}
          >
            Create a new empty import
          </Radio>
          <Radio
            checked={loadRequestFiles}
            className="mt-0"
            name="load-request-files-enable"
            onChange={() => setLoadRequestFiles(true)}
          >
            Upload import request files in a new import
          </Radio>
        </FormGroup>
        {loadRequestFiles && renderBody()}
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-sm btn-cancel" type="button" onClick={handleCancel}>Cancel</button>
        <button className="btn btn-sm btn-save" type="button" onClick={handleCreate}>
          Create Import
        </button>
      </Modal.Footer>
    </Modal>
  );
}

CreateImportModal.propTypes = {
  requestFiles: PropTypes.array.isRequired,
  shown: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onCreateImport: PropTypes.func.isRequired
};
